import posed from './posed';
import Transition from './components/Transition';
export default posed;
export { Transition };
//# sourceMappingURL=index.js.map